import { useState, useContext } from 'react';
import { Container, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { Redirect } from 'react-router';
import { AuthenticationContext } from '../msal/AuthenticationContext';
import { TenantContext } from '../context/TenantContext';
import { urls } from '../logic/urls';

import css from './CreateTenant.module.scss';
import sharedCss from './Shared.module.scss';

export const CreateTenant = () => {
    const authenticationContext = useContext(AuthenticationContext);
    const tenantContext = useContext(TenantContext);

    const [tenantLabel, setTenantLabel] = useState('');
    const [isCreating, setIsCreating] = useState(false);
    const [error, setError] = useState('');

    // If the user is not authenticated, redirect to home / login
    if (!authenticationContext.isAuthenticated()) {
        return <Redirect to={urls.home} />;
    }

    // If the user already has tenants, redirect to the portal
    if (tenantContext.hasLoadedTenants && tenantContext.availableTenants.length > 0) {
        return <Redirect to={urls.license} />;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!tenantLabel.trim()) {
            setError('Please enter a tenant name.');
            return;
        }

        setIsCreating(true);

        const success = await tenantContext.createTenant(tenantLabel.trim());

        if (success) {
            // TenantContext will refresh and pick up the new tenant.
            // The redirect above will trigger once availableTenants is populated.
        } else {
            setError('Failed to create the tenant. Please try again.');
        }

        setIsCreating(false);
    };

    return (
        <div className={sharedCss.background}>
            <Container fluid={true} className="px-0">
                <div className="bg-secondary d-flex justify-content-between align-items-center p-3">
                    <img style={{ height: '2.5rem', width: 'auto' }} src="./images/Robin-logo-500-blue.png" alt="Robin logo" />
                </div>
            </Container>

            <div className={css.container}>
                <div className={css.card}>
                    <h3 className={css.title}>Create Your Tenant</h3>
                    <p className={css.subtitle}>
                        No tenant is associated with your account yet. Create one to get started.
                    </p>

                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label for="tenantLabel">Tenant Name</Label>
                            <Input
                                id="tenantLabel"
                                type="text"
                                placeholder="Enter a name for your tenant"
                                value={tenantLabel}
                                onChange={(e) => setTenantLabel(e.target.value)}
                                disabled={isCreating}
                                autoFocus
                            />
                        </FormGroup>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        <Button color="primary" type="submit" disabled={isCreating} block>
                            {isCreating ? 'Creating...' : 'Create Tenant'}
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    );
};
